module.exports = __webpack_public_path__ + "img/Captcha.1cf12e69.svg";